import { render, staticRenderFns } from "./EmpresaNovedades.vue?vue&type=template&id=28b6c5fb&scoped=true"
import script from "./EmpresaNovedades.vue?vue&type=script&lang=js"
export * from "./EmpresaNovedades.vue?vue&type=script&lang=js"
import style0 from "./EmpresaNovedades.vue?vue&type=style&index=0&id=28b6c5fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b6c5fb",
  null
  
)

export default component.exports